import { FC } from 'react'
import RichTextBox from '../../components/custom_components/RichTextBox'
import { FullMeetingFragment } from '../../types'
import { Card } from 'antd'

interface Props {
  meeting: FullMeetingFragment
}

export const AgendaOtherMeeting: FC<Props> = ({ meeting }) => {
  return (
    <Card className="fullHeight" bordered={false}>
      <div data-e2e-other-meeting-agenda>
        <RichTextBox text={meeting.other && meeting.other.agenda ? meeting.other.agenda : ''} readonly />
      </div>
    </Card>
  )
}
